<template>

    <v-card>
        <v-card-title>{{templateTypeTitle}} Email Templates</v-card-title>
        <v-divider />

        <v-card-text class="pa-4" >
            <v-window v-model="windowPage" style="height: calc(90vh - 145px);" touchless>
                <v-window-item :key="0">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="text-left">Name</th>
                                <th class="text-left">Owner</th>
                                <th class="text-left">Private/Public</th>
                                <th class="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="cursor: pointer" v-for="view in $props.emailTemplates" :key="view.view_id" @click="selectView(view)">
                                <td>{{ view.view_name }}</td>
                                <td>{{ usernameLookup(view.user_id) }}</td>
                                <td>
                                    <v-switch class="public-switch" color="#c42111" :ripple="true" :input-value="view.view_public" :disabled="view.user_id != $store.state.user.user_id" @click.native.capture.stop="publicClick(view)">
                                        <template v-slot:label>
                                            <label>
                                                {{ view.view_public ? 'public' : 'private' }}
                                            </label>
                                        </template>
                                    </v-switch>
                                </td>
                                <td>
                                    <v-btn icon color="#DC3545" :disabled="view.user_id != $store.state.user.user_id" @click.stop="deleteViewClick(view)"><v-icon la>mdi-delete-forever</v-icon></v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-btn color="#c42111" class="mt-2" @click="addNewTemplateClick">Add New</v-btn>
                </v-window-item>

                <v-window-item :key="1">
                    <div v-if="selectedEmailTemplateClone">
                        <v-col cols="12">
                            <v-text-field ref="emailTemplateName" label="Template Name" color="#c42111" v-model="selectedEmailTemplateClone.view_name" :rules="[$store.state.validationFuncs.required(selectedEmailTemplateClone.view_name, 'Template Name')]" />
                            <v-text-field id="email-subject" label="Email Subject" color="#c42111" v-model="selectedEmailTemplateClone.view_grid_config.emailSubject">
                                <template v-slot:append>
                                    <v-menu offset-y allow-overflow max-height="500px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <svg class="ck ck-icon ck-reset_all-excluded ck-icon_inherit-color ck-button__icon" viewBox="0 0 20 20" aria-hidden="true">
                                                    <circle fill="#ffffff" cx="10.0001" cy="9.79993" r="1.5"></circle>
                                                    <path fill="#ffffff" d="M13.2496 2.75005C13.2497 2.00005 13.2498 2.00005 13.2498 2.00005L13.2511 2.00005L13.2534 2.00006L13.2606 2.00009L13.2848 2.0003C13.3052 2.00053 13.3337 2.00098 13.3688 2.00185C13.4386 2.0036 13.536 2.00707 13.6475 2.01402C13.8589 2.02722 14.1651 2.05536 14.4328 2.12276C14.8296 2.22267 15.1705 2.40399 15.4402 2.67392C15.7077 2.94161 15.8688 3.26001 15.9644 3.5803C16.1459 4.18776 16.1145 4.89393 16.0724 5.49256C16.0626 5.6324 16.052 5.76849 16.0416 5.90131C16.0036 6.38849 15.969 6.83163 15.9895 7.25369C16.0151 7.78147 16.1252 8.13279 16.3222 8.3656C16.5447 8.6286 16.8158 8.79405 17.0411 8.89436C17.1523 8.94386 17.2471 8.97509 17.3103 8.99319C17.3417 9.00219 17.3647 9.00776 17.3773 9.01062L17.3868 9.01269L17.9996 9.12173V9.75005H15.5976C15.4541 9.63123 15.3117 9.49364 15.1771 9.33451C14.669 8.73405 14.5235 7.99036 14.4913 7.32643C14.4657 6.79933 14.5105 6.23163 14.5497 5.73429C14.5592 5.61404 14.5683 5.49785 14.5761 5.3874C14.6198 4.76596 14.62 4.32043 14.5272 4.00956C14.4857 3.87069 14.4332 3.78828 14.3791 3.73414C14.3272 3.68223 14.2386 3.6207 14.0665 3.57736C13.9372 3.5448 13.7433 3.52293 13.554 3.51111C13.4651 3.50556 13.3869 3.50277 13.3313 3.50139C13.3037 3.5007 13.282 3.50036 13.2678 3.5002L13.2524 3.50007L13.2493 3.50005L12.4996 3.5L12.4997 2L13.2498 2.00005L13.2496 2.75005Z"></path>
                                                    <path fill="#ffffff" d="M13.2496 16.7501C13.2497 17.5001 13.2498 17.5001 13.2498 17.5001L13.2511 17.5001L13.2534 17.5001L13.2606 17.5L13.2848 17.4998C13.3052 17.4996 13.3337 17.4991 13.3688 17.4983C13.4386 17.4965 13.536 17.493 13.6475 17.4861C13.8589 17.4729 14.1651 17.4448 14.4328 17.3774C14.8296 17.2774 15.1705 17.0961 15.4402 16.8262C15.7077 16.5585 15.8688 16.2401 15.9644 15.9198C16.1459 15.3124 16.1145 14.6062 16.0724 14.0076C16.0626 13.8677 16.052 13.7316 16.0416 13.5988C16.0036 13.1116 15.969 12.6685 15.9895 12.2464C16.0151 11.7186 16.1252 11.3673 16.3222 11.1345C16.5447 10.8715 16.8158 10.7061 17.0411 10.6058C17.1523 10.5563 17.2471 10.525 17.3103 10.5069C17.3417 10.4979 17.3647 10.4924 17.3773 10.4895L17.3868 10.4874L17.9996 10.3784V9.75005H15.5976C15.4541 9.86887 15.3117 10.0065 15.1771 10.1656C14.669 10.7661 14.5235 11.5098 14.4913 12.1737C14.4657 12.7008 14.5105 13.2685 14.5497 13.7658C14.5592 13.8861 14.5683 14.0023 14.5761 14.1127C14.6198 14.7341 14.62 15.1797 14.5272 15.4906C14.4857 15.6294 14.4332 15.7118 14.3791 15.766C14.3272 15.8179 14.2386 15.8794 14.0665 15.9228C13.9372 15.9553 13.7433 15.9772 13.554 15.989C13.4651 15.9945 13.3869 15.9973 13.3313 15.9987C13.3037 15.9994 13.282 15.9998 13.2678 15.9999L13.2524 16L13.2493 16.0001L12.4996 16.0001L12.4997 17.5001L13.2498 17.5001L13.2496 16.7501Z"></path>
                                                    <path fill="#ffffff" d="M6.75 2.75005C6.74995 2.00005 6.74982 2.00005 6.74982 2.00005L6.74853 2.00005L6.74622 2.00006L6.73903 2.00009L6.71478 2.0003C6.69446 2.00053 6.66594 2.00098 6.63087 2.00185C6.56099 2.0036 6.46364 2.00707 6.35217 2.01402C6.14071 2.02722 5.83458 2.05536 5.56688 2.12276C5.17006 2.22267 4.82913 2.40399 4.55943 2.67392C4.29196 2.94161 4.13085 3.26001 4.03519 3.5803C3.85377 4.18776 3.88516 4.89393 3.92723 5.49256C3.93706 5.6324 3.94768 5.76849 3.95804 5.90131C3.99605 6.38849 4.03062 6.83163 4.01013 7.25369C3.98451 7.78147 3.87445 8.13279 3.67746 8.3656C3.45492 8.6286 3.18386 8.79405 2.95851 8.89436C2.84732 8.94386 2.75258 8.97509 2.68931 8.99319C2.65789 9.00219 2.63488 9.00776 2.62229 9.01062L2.61279 9.01269L2 9.12173V9.75005H4.40205C4.54555 9.63123 4.6879 9.49364 4.82254 9.33451C5.33063 8.73405 5.47613 7.99036 5.50837 7.32643C5.53396 6.79933 5.48918 6.23163 5.44995 5.73429C5.44047 5.61404 5.4313 5.49785 5.42354 5.3874C5.37987 4.76596 5.37961 4.32043 5.47246 4.00956C5.51394 3.87069 5.56644 3.78828 5.62053 3.73414C5.6724 3.68223 5.76099 3.6207 5.93312 3.57736C6.06245 3.5448 6.25632 3.52293 6.4456 3.51111C6.5345 3.50556 6.61271 3.50277 6.6683 3.50139C6.69595 3.5007 6.71765 3.50036 6.73185 3.5002L6.74724 3.50007L6.75029 3.50005L7.50005 3.5L7.49995 2L6.74982 2.00005L6.75 2.75005Z"></path>
                                                    <path fill="#ffffff" d="M6.75 16.7501C6.74995 17.5001 6.74982 17.5001 6.74982 17.5001L6.74853 17.5001L6.74622 17.5001L6.73903 17.5L6.71478 17.4998C6.69446 17.4996 6.66594 17.4991 6.63087 17.4983C6.56099 17.4965 6.46364 17.493 6.35217 17.4861C6.14071 17.4729 5.83458 17.4448 5.56688 17.3774C5.17006 17.2774 4.82913 17.0961 4.55943 16.8262C4.29196 16.5585 4.13085 16.2401 4.03519 15.9198C3.85377 15.3124 3.88516 14.6062 3.92723 14.0076C3.93706 13.8677 3.94768 13.7316 3.95804 13.5988C3.99605 13.1116 4.03062 12.6685 4.01013 12.2464C3.98451 11.7186 3.87445 11.3673 3.67746 11.1345C3.45492 10.8715 3.18386 10.7061 2.95851 10.6058C2.84732 10.5563 2.75258 10.525 2.68931 10.5069C2.65789 10.4979 2.63488 10.4924 2.62229 10.4895L2.61279 10.4874L2 10.3784V9.75005H4.40205C4.54555 9.86887 4.6879 10.0065 4.82254 10.1656C5.33063 10.7661 5.47613 11.5098 5.50837 12.1737C5.53396 12.7008 5.48918 13.2685 5.44995 13.7658C5.44047 13.8861 5.4313 14.0023 5.42354 14.1127C5.37987 14.7341 5.37961 15.1797 5.47246 15.4906C5.51394 15.6294 5.56644 15.7118 5.62053 15.766C5.6724 15.8179 5.76099 15.8794 5.93312 15.9228C6.06245 15.9553 6.25632 15.9772 6.4456 15.989C6.5345 15.9945 6.61271 15.9973 6.6683 15.9987C6.69595 15.9994 6.71765 15.9998 6.73185 15.9999L6.74724 16L6.75029 16.0001L7.50005 16.0001L7.49995 17.5001L6.74982 17.5001L6.75 16.7501Z"></path>
                                                </svg>
                                                <svg class="ck ck-icon ck-reset_all-excluded ck-icon_inherit-color ck-dropdown__arrow" viewBox="0 0 10 10" aria-hidden="true"><path fill="#ffffff" d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"></path></svg>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item v-for="(tag, index) in alarmTags" :key="index" link @click="insertTagSubject(tag)">
                                                <v-list-item-title>{{ tag.text }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <email-builder ref="emailbuilder" :tags="alarmTags" :subject="selectedEmailTemplateClone.view_grid_config.emailSubject" />
                        </v-col>
                    </div>
                </v-window-item>
            </v-window>
        </v-card-text>

        <v-divider />
        <v-card-actions>
            <v-spacer />
            <template v-if="windowPage === 0">
                <v-btn text @click="$emit('close')">Close</v-btn>
            </template>
            <template v-else-if="windowPage === 1">
                <v-btn text @click="cancelClick">Cancel</v-btn>
                <v-btn text @click="saveClick">Save</v-btn>
            </template>
        </v-card-actions>


        <v-dialog v-model="showViewsFavsDetails" max-width="80%" width="550px" persistent v-if="showViewsFavsDetails" @keydown="(k) => {k.key == 'Escape' ? showViewsFavsDetails = false : null}">
            <views-favs-details :viewType="$props.templateType" :selectedView="selectedEmailTemplateClone" :views="$props.emailTemplates" @cancel="showViewsFavsDetails = false" @new="saveNewView" @overwrite="overwriteView"></views-favs-details>
        </v-dialog>

    </v-card>

</template>

<script>
import EmailBuilder from "@/components/Settings/EmailBuilder";
import AlarmsList from "@/components/Alarms/AlarmsList";
import ViewsFavsDetails from "@/components/ViewsFavsDetails";
export default {
    name: 'EmailTemplates',
    props: ['templateType', 'emailTemplates'],
    components: {
        EmailBuilder,
        AlarmsList,
        ViewsFavsDetails
    },
    data: () => ({
        windowPage: 0,
        selectedEmailTemplate: null,
        selectedEmailTemplateClone: null,
        showViewsFavsDetails: false,

        alarmTags: [
            {text: 'Acked By', value: 'alarm_ack_user'},
            {text: 'Clear Time', value: 'alarm_clear_time'},
            {text: 'Cleared By', value: 'alarm_clear_user'},
            {text: 'Description', value: 'alarm_description'},
            {text: 'Facility', value: 'alarm_facility_type'},
            {text: 'Alarm Full Text', value: 'alarm_full_text'},
            {text: 'History', value: 'alarm_history'},
            //{text: 'Alarm ID', value: 'alarm_id'},
            //{text: 'Alarm Key String', value: 'alarm_key_str'},
            {text: 'Alarm Time', value: 'alarm_time'},
            {text: 'Alarm Local Time', value: 'alarm_local_time'},
            {text: 'Location', value: 'alarm_location'},
            {text: 'Office', value: 'alarm_office'},
            {text: 'Remarks', value: 'alarm_remarks'},
            {text: 'Repeats', value: 'alarm_repeats'},
            {text: 'Service Affecting', value: 'alarm_service_affecting'},
            {text: 'Severity', value: 'alarm_severity'},
            {text: 'Page Time', value: 'paged_times'},
            {text: 'Paged To', value: 'paged_users'},
            //{text: 'Site ID', value: 'site_id'},
            {text: 'Locale', value: 'site_locale'},
            {text: 'Site Name', value: 'site_name'},
            {text: 'Site Tags', value: 'site_tags'},
            {text: 'Technician', value: 'user_username'},
        ]
    }),

    computed: {
        templateTypeTitle() {
            if(this.$props.templateType == 'alarm_email') {
                return 'Alarm';
            }
        },

        tags() {
            if(this.$props.templateType == 'alarm_email') {
                return this.alarmTags;
            }
        }
    },

    methods: {
        getEmailTemplates() {
            let route = `${TELSA.apiHost}views/list/alarm_email`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                console.log('EMAIL TEMPLATES: ', results);
                this.$props.emailTemplates = results;
            });
        },

        selectView(view) {
            if(this.selectedEmailTemplate) {
                return; // protects agains dbl clicking and setTimeout
            }
            this.selectedEmailTemplate = view;
            this.selectedEmailTemplateClone = JSON.parse(JSON.stringify(view));
            this.windowPage = 1;
            // this.$nextTick(function() {
            //     this.$refs.emailbuilder.initializeEditor(this.selectedEmailTemplateClone.view_grid_config.emailBody);
            // });
            setTimeout(() => this.$refs.emailbuilder.initializeEditor(this.selectedEmailTemplateClone.view_grid_config.emailBody), 200);
        },

        cancelClick() {
            this.windowPage = 0;
            this.selectedEmailTemplate = null;
            this.selectedEmailTemplateClone = null;
        },

        addNewTemplateClick() {
            console.log('add new tempate');
            this.selectedEmailTemplateClone = {
                view_id: 0,
                user_id: this.$store.state.user.user_id,
                view_type: 'alarm_email',
                view_name: '',
                view_device_type: '',
                view_public: false,
                view_grid_config: {
                    emailSubject: '',
                    emailBody: ''
                }
            };
            this.windowPage = 1;
            setTimeout(() => this.$refs.emailbuilder.initializeEditor(this.selectedEmailTemplateClone.view_grid_config.emailBody), 200);
        },

        saveClick() {
            if(!this.$refs.emailTemplateName.validate(true)) {
                return;
            }
            this.selectedEmailTemplateClone.view_grid_config.emailBody = this.$refs.emailbuilder.editorObj.getData();
            console.log('SAVE THIS: ', this.selectedEmailTemplateClone);

            if(this.selectedEmailTemplateClone.view_id) {
                this.showViewsFavsDetails = true;
            }
            else {
                this.saveNewView();
            }
            
            return;

            TELSA.loading(true);
            if(this.selectedEmailTemplateClone.view_id) {
                // Edit
                this.saveView(this.selectedEmailTemplateClone, this.selectedEmailTemplate.view_name);
            }
            else {
                // Add New
                let route = `${TELSA.apiHost}views/add`;
                delete this.selectedEmailTemplateClone.view_id;
                return this.$http.post(route, {args: {view: this.selectedEmailTemplateClone}}).then(response => {
                    let result = response.body;
                    this.saveViewsFavs();
                    TELSA.loading(false);
                });
            }
        },

        saveNewView(newView) {
            console.log('newView: ', newView);
            if(newView) {
                this.selectedEmailTemplateClone.view_name = newView.viewName;
                this.selectedEmailTemplateClone.view_public = newView.viewPublic;
            }
            TELSA.loading(true);
            let route = `${TELSA.apiHost}views/add`;
            this.selectedEmailTemplateClone.user_id = this.$store.state.user.user_id;
            delete this.selectedEmailTemplateClone.view_id;
            return this.$http.post(route, {args: {view: this.selectedEmailTemplateClone}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
                this.showViewsFavsDetails = false;
            });
        },

        overwriteView() {
            let view = this.selectedEmailTemplateClone;
            let oldViewName = this.selectedEmailTemplate.view_name;
            TELSA.loading(true);
            let route = `${TELSA.apiHost}views/edit`;
            return this.$http.post(route, {args: {view: view, old_view_name: oldViewName}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
                this.showViewsFavsDetails = false;
            });
        },

        saveView(view, oldViewName) {
            // let view = this.selectedEmailTemplateClone;
            // let oldViewName = this.selectedEmailTemplate.view_name;
            TELSA.loading(true);
            let route = `${TELSA.apiHost}views/edit`;
            return this.$http.post(route, {args: {view: view, old_view_name: oldViewName}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
            });
        },




        saveViewsFavs() {
            let viewsFavs = [];
            for(let view of this.$props.emailTemplates) {
                if(view.fav) {
                    viewsFavs.push({
                        user_id: view.user_id,
                        view_name: view.view_name,
                        default: view.default
                    });
                }
            }

            let route = `${TELSA.apiHost}views/favs`;
            return this.$http.post(route, {args: {view_type: this.$props.templateType, views_favs: viewsFavs}}).then(response => {
                let result = response.body;
                this.$emit('get');
                this.cancelClick();
                TELSA.loading(false);
            });
        },

        usernameLookup(userId) {
            for(let user of this.$store.state.batchConfig.users) {
                if(user.user_id == userId) {
                    return user.user_username;
                }
            }
            return '';
        },

        publicClick(view) {
            // Warn them if they are making a public view private.
            if(view.view_public) {
                this.$store.commit('showConfirmModal', {
                    title: 'Confirm Overwrite',
                    message: `Making this view private will prevent other users from continuing to use it. Are you sure you want to do this?`,
                    type: 'warning',
                    hideCancel: false,
                    confirmAction: () => {view.view_public = false; this.saveView(view, view.view_name);}
                });
            }
            else {
                view.view_public = true;
                this.saveView(view, view.view_name);
            }
        },








        deleteViewClick(view) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: `Deleting this email template will prevent other users from continuing to use it. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteView(view)
            });
        },
        deleteView(view) {
            TELSA.loading(true);
            this.$props.emailTemplates.splice(this.$props.emailTemplates.indexOf(view), 1);
            let route = `${TELSA.apiHost}views/delete`;
            return this.$http.post(route, {args: {view: view}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
                // If the view we just deleted is the one we're looking at, then remove that too.
                if(view == this.selectedEmailTemplate) {
                    this.selectedEmailTemplate = null;
                    this.selectedEmailTemplateClone = null;
                }
                TELSA.loading(false);
            });
        },

        insertTagSubject(tag) {
            let position = document.getElementById('email-subject').selectionStart;
            if(position != null) {
                let s = this.selectedEmailTemplateClone.view_grid_config.emailSubject
                s = s.slice(0, position) + `{{${tag.value}}}` + s.slice(position);
                this.selectedEmailTemplateClone.view_grid_config.emailSubject = s;
            }
            else {
                this.selectedEmailTemplateClone.view_grid_config.emailSubject += `{{${tag.value}}}`;
            }
        }

    },

    created() {
    },

    mounted() {
    },

    destroyed() {
        
    }

  
};
</script>
